$(document).ready(function() {
    const addresses = {
        isLoadingAddress: false,
        init() {
            $(document).on('click', '#add-new-address', this, this.addNewAddressModal);
            $(document).on('click', '.edit-address', this, this.editAddressModal);
            $(document).on('click', '#save-address', this, this.updateAddress);
            $(document).on('click', '#save-new-address', this, this.saveAddress);
            $(document).on('click', '.delete-address', this, this.deleteAddress);
            $(document).on('change', '#address-county', this, this.getCities);
        },
        getCities(getCities) {

        },
		editAddressModal(event) {
			const _this = event.data;
			var id = $(this).data('id');
			if (!id) { return false; }

			$.ajax({
                type: "GET",
                url: `${baseURL}/account/address/${id}`,
				success: function(response, xhr) {
					if (response == 'invalid-id') {
						alert('Invalid ID!');
						return false;
					}

                    $('#address-modal').html(response);
                    $('#address-modal').modal();
                },
                error(error) {
                    console.log(error);
                },
			});
		},
		updateAddress(event) {
            const _this = event.data;
			var id = $(this).data('id');
			if (!id) { return false; }

            if (_this.isLoadingAddress) {
                return false;
            }

            $('.form-edit-address').find('.is-invalid').removeClass('is-invalid');

			var errors = false;
			if ($('#address-name').val() == '') {
				$('#address-name').addClass('is-invalid');
				errors = true;
			}
			if ($('#address-phone').val() == '') {
				$('#address-phone').addClass('is-invalid');
				errors = true;
			}
			if ($('#address-county option:selected').val() == '') {
				$('#address-county').addClass('is-invalid');
				errors = true;
			}
			if ($('#address-city option:selected').val() == '') {
				$('#address-city').addClass('is-invalid');
				errors = true;
			}
			if ($('#address-address').val() == '') {
				$('#address-address').addClass('is-invalid');
				errors = true;
			}
			if (errors) {
				return false;
			}

            //Loading...
            _this.isLoadingAddress = true;

            var values = '_token=' + $('#_token_address').val();
            values += '&id=' + id;
            values += '&name=' + $('#address-name').val();
            values += '&phone=' + $('#address-phone').val();
            values += '&county=' + $('#address-county option:selected').val();
            values += '&city=' + $('#address-city option:selected').val();
            values += '&address=' + $('#address-address').val();

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/update-address`,
                data: values,
                beforeSend: function() {
                    _this.isLoadingAddress = true;
                },
                complete: function() {
                    _this.isLoadingAddress = false;
                },
                success: function(response, xhr) {
                    _this.isLoadingAddress = false;

                    if (response.status == 0) {
                        var errorsHtml = '';
                        for(var errorKey in response.errors) {

                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#"+errorKey).addClass('is-invalid');
                            }
                        }

                        return false;
                    }

                    if (response.status == 1) {
						var rowHtml = `<div class="col-md-9">
								<div class="address-contact">${response.data.name} - ${response.data.phone}</div>
								<div class="address-text">${response.data.address} ${response.data.county}, ${response.data.city}</div>
							</div>
							<div class="col-md-3">
								<a href="javascript:void(0)" data-id="${response.data.id}" class="btn dark nobg transition small edit-address">Modifica</a>
								<a href="javascript:void(0)" data-id="${response.data.id}" class="btn dark nobg transition small delete-address">Sterge</a>
							</div>`;
						$('#address-' + id).html(rowHtml);

                        $('#address-modal').modal('hide');
						$('#address-modal').html('');

						return;
                    }
                },
                error(error) {
                    _this.isLoadingAddress = false;
                },
            });
        },
        deleteAddress(event) {
			const _this = event.data;
			var id = $(this).data('id');
			if (!id) { return false; }

			if (confirm('Esti sigur ca vrei sa stergi adresa?')) {

				if (_this.isLoadingAddress) {
	                return false;
	            }

				//Loading...
	            _this.isLoadingAddress = true;

	            var values = '_token=' + $('#_token_address_list').val();
				values += '&id=' + id;
	            $.ajax({
	                type: "POST",
	                url: `${baseURL}/account/delete-address`,
	                data: values,
	                beforeSend: function() {
	                    _this.isLoadingAddress = true;
	                },
	                complete: function() {
	                    _this.isLoadingAddress = false;
	                },
	                success: function(response, xhr) {
	                    _this.isLoadingAddress = false;

	                    if (response.status == 1) {
							$('#address-' + id).remove();
							return;
	                    }
	                },
	                error(error) {
	                    _this.isLoadingAddress = false;
	                },
	            });

			}
		},
        addNewAddressModal(event) {
			const _this = event.data;

			$.ajax({
                type: "GET",
                url: `${baseURL}/account/address`,
				success: function(response, xhr) {
                    $('#address-modal').html(response);
                    $('#address-modal').modal();
                },
                error(error) {
                    console.log(error);
                },
			});
		},
        saveAddress(event) {
            const _this = event.data;

            if (_this.isLoadingAddress) {
                return false;
            }

            $('.form-new-address').find('.is-invalid').removeClass('is-invalid');

			var errors = false;
			if ($('#address-name').val() == '') {
				$('#address-name').addClass('is-invalid');
				errors = true;
			}
			if ($('#address-phone').val() == '') {
				$('#address-phone').addClass('is-invalid');
				errors = true;
			}
			if ($('#address-county option:selected').val() == '') {
				$('#address-county').addClass('is-invalid');
				errors = true;
			}
			if ($('#address-city option:selected').val() == '') {
				$('#address-city').addClass('is-invalid');
				errors = true;
			}
			if ($('#address-address').val() == '') {
				$('#address-address').addClass('is-invalid');
				errors = true;
			}
			if (errors) {
				return false;
			}

            //Loading...
            _this.isLoadingAddress = true;

            var values = '_token=' + $('#_token_address').val();
            values += '&name=' + $('#address-name').val();
            values += '&phone=' + $('#address-phone').val();
            values += '&county=' + $('#address-county option:selected').val();
            values += '&city=' + $('#address-city option:selected').val();
            values += '&address=' + $('#address-address').val();

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/address`,
                data: values,
                beforeSend: function() {
                    _this.isLoadingAddress = true;
                },
                complete: function() {
                    _this.isLoadingAddress = false;
                },
                success: function(response, xhr) {
                    _this.isLoadingAddress = false;

                    if (response.status == 0) {
                        var errorsHtml = '';
                        for(var errorKey in response.errors) {

                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#"+errorKey).addClass('is-invalid');
                            }
                        }

                        return false;
                    }

                    if (response.status == 1) {
						var rowHtml = `<div class="row wrap-row" id="address-${response.data.id}">
							<div class="col-md-9">
								<div class="address-contact">${response.data.name} - ${response.data.phone}</div>
								<div class="address-text">${response.data.address} ${response.data.county}, ${response.data.city}</div>
							</div>
							<div class="col-md-3">
								<a href="javascript:void(0)" data-id="${response.data.id}" class="btn dark nobg transition small edit-address">Modifica</a>
								<a href="javascript:void(0)" data-id="${response.data.id}" class="btn dark nobg transition small delete-address">Sterge</a>
							</div>
						</div>`;
						$('#addresses-container').prepend(rowHtml);

                        $('#address-modal').modal('hide');
						$('#address-modal').html('');

						return;
                    }
                },
                error(error) {
                    _this.isLoadingAddress = false;
                },
            });
        },

    };

    if ($('.account-addresses-section').length) {
        addresses.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/addresses.js